import { Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Passage } from '../shared/passage/passage';
import { PassageService } from '../shared/passage/passage.service';

@Component({
  selector: 'app-delivery-schedule',
  templateUrl: './delivery-schedule.component.html',
  styleUrls: ['./delivery-schedule.component.scss']
})
export class DeliveryScheduleComponent implements OnInit, OnDestroy {
  @HostBinding('class.clamp') clamp = true;

  passages: Array<Passage>;
  displayedColumns: Array<string> = ['jour', 'num_tournee', 'matin', 'apres_midi', 'sep', 'jrs_relivraison_vt', 'jrs_relivraison_lp', 'jrs_relivraison_sa'];
  private passageSub: Subscription;

  constructor(
    private passageService: PassageService
  ) { }

  ngOnInit() {
    this.passageSub = this.passageService.getPassages().subscribe(
      passages => {
        this.passages = passages.filter(p => p.jour !== 7);
      });
  }

  ngOnDestroy() {
    this.passageSub.unsubscribe();
  }

}
